import type { ReactNode } from "react";

export type TimelineItem = { id: string | number; /** Açık olan (şu an bakılan) versiyon: nokta `--primary`, `aria-current="true"`. */ active?: boolean; children: ReactNode };

/** Dikey versiyon zaman çizgisi (ui.md §12.11): sol 1 px çizgi, her satırda nokta. Yükleme detayı ve Veri Geçmişi ortak kullanır. */
export function VersionTimeline({ items, label, className = "" }: { items: TimelineItem[]; label?: string; className?: string }) {
  return (
    <ol aria-label={label} data-slot="version-timeline" className={`ml-2 flex flex-col gap-3 border-l pl-5 ${className}`}>
      {items.map((it) => (
        <li key={it.id} aria-current={it.active ? "true" : undefined} data-active={it.active ? "true" : undefined} className="relative min-w-0">
          <span aria-hidden="true" className={`absolute top-2 -left-[25.5px] size-2.5 rounded-full ring-4 ring-card ${it.active ? "bg-primary" : "bg-border"}`} />
          {it.children}
        </li>
      ))}
    </ol>
  );
}
